import axiosInstance from "../../../shared/api/axiosInstance";
import { configReq } from "../../../shared/lib/functions";
import { getGatewaySettings } from "./payments";

const endpoint = "admin/v2/PaymentOrders";
const options = (token) => ({ ...configReq(token), timeout: 20000 });
const value = (row, key) => row?.[key] ?? row?.[key[0].toUpperCase() + key.slice(1)];
function assertSandboxOrder(row, customerUserId) {
  if (value(row, "testMode") !== true || value(row, "amountMinor") !== 100 || value(row, "currency") !== "EUR"
    || value(row, "customerUserId") !== customerUserId || !/^[0-9a-f-]{36}$/i.test(value(row, "id") || "")) {
    throw new Error("sandbox-order-mismatch");
  }
}

/** Fixed one-euro sandbox operation; refuses live orders before starting any checkout. */
export async function startSandboxPayment(token, customerUserId, reference) {
  const settings = await getGatewaySettings(token);
  if (!settings.enabled || !settings.testMode || !settings.testKeyConfigured) throw new Error("sandbox-not-ready");
  if (!Number.isSafeInteger(customerUserId) || customerUserId < 1) throw new Error("sandbox-identity-required");
  const order = (await axiosInstance.post(endpoint, { customerUserId, amountMinor: 100, currency: "EUR",
    description: "Digikraam sandbox verification", businessReference: reference }, options(token))).data;
  assertSandboxOrder(order, customerUserId);
  const id = value(order, "id");
  const started = (await axiosInstance.post(`${endpoint}/${id}/checkout`, {}, options(token))).data;
  assertSandboxOrder(started, customerUserId);
  const paymentUrl = new URL(value(started, "paymentUrl"));
  if (paymentUrl.protocol !== "https:" || paymentUrl.username || paymentUrl.password || paymentUrl.port
    || !(paymentUrl.hostname === "multisafepay.com" || paymentUrl.hostname.endsWith(".multisafepay.com"))) {
    throw new Error("sandbox-url-invalid");
  }
  return { id, reference, paymentUrl: paymentUrl.href };
}
